const Apps = () => import(/* webpackChunkName: "Apps" */ "@/views/apps/Apps");
const Links = () => import(/* webpackChunkName: "App Links" */ "@/views/apps/AppLinks");

const appsRoutes = [
  {
    path: "apps",
    name: "Apps",
    redirect: {
      name: "App Links"
    },
    component: Apps,
    children: [
      {
        path: "links",
        name: "App Links",
        component: Links
      }
    ]
  }
];

export default appsRoutes;